import type { ReactNode } from 'react'
import { Footer } from '../components/Footer'
import { Header } from '../components/Header'
import { contentFor } from '../transport/content'
import type { Locale } from '../transport/types'

export function SiteLayout({
  locale,
  children,
}: {
  locale: Locale
  children: ReactNode
}) {
  const content = contentFor(locale)
  return (
    <div className="site map-site" dir={content.dir}>
      <a className="skip-link" href="#main-content">
        {locale === 'ar' ? 'تخطي إلى الخريطة' : 'Skip to map'}
      </a>
      <Header locale={locale} />
      <main id="main-content">{children}</main>
      <Footer locale={locale} />
    </div>
  )
}
